import React from 'react'
import {FormattedMessage} from 'react-intl'

const NoEstateFound = _ =>

<div className="no-estate-found-container">
  <div className= "well">
    <h4 className="no-estate-found-tile">
      <FormattedMessage
        id="No estate"
        defaultMessage="No estate"/>
    </h4>
    <p>
      <FormattedMessage
        id="No estates matchs your query."
        defaultMessage="No estate matchs your query."/>
    </p>
  </div>
</div>

export default NoEstateFound




/** WEBPACK FOOTER **
 ** ./app/components/NoEstateFound.jsx
 **/